export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8452.ac51f774.jpg";